import { ViewModel,View, ObservableArray, ViewModelMessage } from "binder"
import { IFormBuilderPart } from "src/formBuilder/formBuilder/formBuilder/formBuilder-viewModel";
import { BooleanType, DataModel, DateType, FloatType, IntegerType, KnownClassType, ListType, PropertyType, ServerSideDataLoaderType, StringType, VoidType } from "../structure";
import  { DataModelBuilderView } from "./dataModelBuilder-view"
import { DataModelJsonSerializer } from "./serialization/dataModeltoJsonSerializer";
import { MethodManipulationViewModel } from "./methodManipulation/methodManipulation-viewModel";
import { PropertyManipulationViewModel } from "./propertyManipulation/propertyManipulation-viewModel";
import { DataModelFromJsonDeserializer } from "./serialization/dataModelFromJsonDeserializer";
import { FormBuilderWindowViewModel } from "src/formBuilder/formBuilder/formBuilderWindow-viewModel";
import { ServerSideDataLoader } from "uicomponents";
import { ExportViewModel } from "src/bpms/rawData/processDefinition/processForms/export/export-viewModel";
import { ImportViewModel } from "src/bpms/rawData/processDefinition/processForms/import/import-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { MethodBodyCodeEditorViewModel } from "./methodBodyCodeEditor/methodBodyCodeEditor-viewModel";
import { PropertyBodyCodeEditorViewModel } from "./propertyBodyCodeEditor/propertyBodyCodeEditor-viewModel";
import { DataModelToSourceCodeConverter } from "./datamodelToSourceCodeConverter";
import moment from "moment";
export class DataModelBuilderViewModel extends ViewModel implements IFormBuilderPart{
    static newWindowId:number =0;

    constructor(parentViewModel: FormBuilderWindowViewModel) {
        super(parentViewModel);
        this.typedParent = parentViewModel;
        this.partName = 'مدل داده';
        this.classes = ObservableArray.create<DataModelClass>();
    }
    GetDefaultView(): View <ViewModel> {
        return new DataModelBuilderView();
    }
    public getTypeId(): string {
        return "VM-08B81BB5-A201-472C-AA71-5B2636F3BBAC"
    }
    private typedParent : FormBuilderWindowViewModel;
    public set classes(v: ObservableArray<DataModelClass>) { this._classes = v; } public get classes(): ObservableArray<DataModelClass> { return this._classes;} private _classes: ObservableArray<DataModelClass>;
    public set partName(v: string) { this._partName = v; } public get partName(): string { return this._partName;} private _partName: string;
    
    addNewClass() : DataModelClass{
        let result = new DataModelClass(this);
        this.classes.push(result);
        return result;
    }

    removeClass(cls:DataModelClass){
        this.classes.remove(cls);
    }

    handleMessage(msg:ViewModelMessage){
        if(msg instanceof GetAllPropertyTypesMessage){
            msg.types = [
                new BooleanType(this),
                new IntegerType(this),
                new FloatType(this),
                new StringType(this),
                new ListType(this),
                new KnownClassType(this),
                new ServerSideDataLoaderType(this),
                new DateType(this)
            ];
            if(msg.allowVoid){
                msg.types.push(new VoidType(this));
            }
            return msg;
        }else if(msg instanceof GetAllClassesMessage){
            msg.classes = [...this.classes];
            return msg;
        }else{
            return super.handleMessage(msg);
        }
    }
    save(){
        try{
            this.typedParent.updateDataModel();
            this.messageBoxConfirmSuccess("عملیات با موفقیت انجام شد.","عملیات موفق");
        }catch{
            this.messageBoxConfirmWarning("خطا در عملیات.","خطا در عملیات");
        }
    }
    getDataModelJson():any{
        return new DataModelJsonSerializer().serialize(this);
    }
    updateModelFromJson(json){
        this.classes.clear();
        new DataModelFromJsonDeserializer().deserialize(this,json);
    }

    
    export(){
        let json = this.getDataModelJson();
        let exporter = new ExportViewModel(this);
        exporter.text = JSON.stringify(json);
        this.requestShowingPopup(exporter);
    }
    async import(){
        let importer = new ImportViewModel(this);
        let result = await this.requestShowingPopup(importer);
        if(stringIsNullOrEmpty(result)==false){
            let json = JSON.parse(result);
            this.updateModelFromJson(json);
        }
    }

    edit(){
        DataModelBuilderViewModel.newWindowId = new Date().getTime();
        let newWindow = window.open(`/codeEditor.html?a=${DataModelBuilderViewModel.newWindowId}`);
        let handler =(msg:MessageEvent<any>)=>{
            let data = msg.data;
            switch(data.type){
                case "ready":
                    bus.postMessage({
                        type:'codeSend',
                        code : new DataModelToSourceCodeConverter().getSourceCode(this)
                    })
                    break;
                case "newModel":
                    let newModel = data.model;
                    let currentModel = this.getDataModelJson();
                    newModel.classes.forEach(cls => {
                        let relatedClasses = currentModel.classes.filter(x=>x.name==cls.name);
                        if(relatedClasses.length!=0){
                            let relatedClass = relatedClasses[0];
                            cls.properties.forEach(prop => {
                                let relatedProperties = relatedClass.properties.filter(x=>x.name==prop.name);
                                if(relatedProperties.length!=0){
                                    let relatedProperty = relatedProperties[0];
                                    if(prop.type==relatedProperty.type){
                                        prop.initialize = relatedProperty.initialize;
                                        prop.default = relatedProperty.default;
                                    }
                                }
                            });
                        }
                    });
                    this.updateModelFromJson(newModel);
                    break;
            }
        };
        let bus = new BroadcastChannel(`code-channel-${DataModelBuilderViewModel.newWindowId}`);
        bus.onmessage = handler;
        newWindow.onbeforeunload  = ()=>{
            console.log('unload');
            window.removeEventListener('message',handler);
        }
    }
}
export interface IMemberContainer{
    addNewProperty(p: Property);
    addNewMethod(m: Method);
    removeProperty(p:Property);
    removeMethod(m:Method);
    getDataModel():DataModelBuilderViewModel;
    getClass():DataModelClass;
}

export class DataModelClass extends ViewModel implements IMemberContainer{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:DataModelBuilderViewModel) {
        super(parent);
        this.dataModel = parent;
        this.properties = ObservableArray.create<Property>();
        this.methods = ObservableArray.create<Method>();

    }
    getDataModel(): DataModelBuilderViewModel {
        return this.dataModel;
    }
    getClass(): DataModelClass {
        return this;
    }
    
    public set dataModel(v: DataModelBuilderViewModel) { this._dataModel = v; } public get dataModel(): DataModelBuilderViewModel { return this._dataModel;} private _dataModel: DataModelBuilderViewModel;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    
    public set properties(v: ObservableArray<Property>) { this._properties = v; } public get properties(): ObservableArray<Property> { return this._properties;} private _properties: ObservableArray<Property>;
    public set methods(v: ObservableArray<Method>) { this._methods = v; } public get methods(): ObservableArray<Method> { return this._methods;} private _methods: ObservableArray<Method>;
    
    async addProperty(){
        let popup = new PropertyManipulationViewModel(this);
        popup.cls = this;
        let result = await this.requestShowingPopup(popup);
        if(result!=null){
            this.properties.push(result);
        }
    }
    async addMethod(){
        let popup = new MethodManipulationViewModel(this);
        popup.cls = this;
        let result = await this.requestShowingPopup(popup);
        if(result!=null){
            this.methods.push(result);
        }
    }
    addNewProperty(p: Property) {
        this.properties.push(p);
    }
    addNewMethod(m: Method) {
        this.methods.push(m);
    }
    removeProperty(p:Property){
        this.properties.remove(p);
    }
    removeMethod(m:Method){
        this.methods.remove(m);
    }
}

export class Property extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.typedParent = <IMemberContainer><any>parent;
    }
    private typedParent : IMemberContainer;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set shallInitialize(v: boolean) { this._shallInitialize = v; } public get shallInitialize(): boolean { return this._shallInitialize;} private _shallInitialize: boolean;
    public set defaultValue(v: string) { this._defaultValue = v; } public get defaultValue(): string { return this._defaultValue;} private _defaultValue: string;
    public set type(v: PropertyType) { this._type = v; } public get type(): PropertyType { return this._type;} private _type: PropertyType;
    public set preBody(v: any) { this._preBody = v; } public get preBody(): any { return this._preBody;} private _preBody: any;
    public set postBody(v: any) { this._postBody = v; } public get postBody(): any { return this._postBody;} private _postBody: any;
    
    remove(){
        this.typedParent.removeProperty(this);
    }

    async edit(){
        let popup = new PropertyManipulationViewModel(this);
        popup.cls = this.typedParent;
        popup.editProperty(this);
        let result = await this.requestShowingPopup(popup);
        if(result!=null){
            this.remove();
            this.typedParent.addNewProperty(result);
        }

    }

    async editPrePost(){
        let popup = new PropertyBodyCodeEditorViewModel(this);
        popup.model = this.typedParent.getDataModel();
        popup.currentClass = this.typedParent.getClass();
        popup.currentProperty = this;
        let result = await this.requestShowingPopup(popup);
        if(result==null){
            return;
        }
        this.preBody = [{
            Type:'JsCode',
            Code : result.pre
        }];
        this.postBody = [{
            Type:'JsCode',
            Code : result.post
        }];
    }
}

export class Method extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.typedParent = <IMemberContainer><any>parent;
        this.arguments = ObservableArray.create<methodParameters>();
    }
    private typedParent : IMemberContainer;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set isAsync(v: boolean) { this._isAsync = v; } public get isAsync(): boolean { return this._isAsync;} private _isAsync: boolean;
    public set arguments(v: ObservableArray<methodParameters>) { this._arguments = v; } public get arguments(): ObservableArray<methodParameters> { return this._arguments;} private _arguments: ObservableArray<methodParameters>;
    public set returnType(v: PropertyType) { this._returnType = v; } public get returnType(): PropertyType { return this._returnType;} private _returnType: PropertyType;
    public set body(v: any) { this._body = v; } public get body(): any { return this._body;} private _body: any;
    
    remove(){
        this.typedParent.removeMethod(this);
    }

    async edit(){
        let popup = new MethodManipulationViewModel(this);
        popup.cls = this.typedParent;
        popup.editMethod(this);
        let result = await this.requestShowingPopup(popup);
        if(result!=null){
            this.remove();
            this.typedParent.addNewMethod(result);
        }

    }
    async edit2(){
        let popup = new MethodBodyCodeEditorViewModel(this);
        popup.model = this.typedParent.getDataModel();
        popup.currentClass = this.typedParent.getClass();
        popup.currentMethod = this;
        try{
            popup.code = this.body[0].Code;        
        }catch{
            popup.code = '';
        }
        if(popup.code==undefined){
            popup.code = '';
        }
        let result = await this.requestShowingPopup(popup);
        if(result==null){
            return;
        }
        this.body = [{
            Type:'JsCode',
            Code : result
        }];
    }
}
export class methodParameters extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set type(v: PropertyType) { this._type = v; } public get type(): PropertyType { return this._type;} private _type: PropertyType;
    
}

export class GetAllPropertyTypesMessage extends ViewModelMessage{
    public types:PropertyType[];
    public allowVoid:boolean = false;
}
export class GetAllClassesMessage extends ViewModelMessage{
    public classes:DataModelClass[];
}
